document.addEventListener('DOMContentLoaded', function () {

  // Target element - "page-header" tag ya #pageheader div
  var header = document.querySelector('page-header') || document.getElementById('pageheader');

  // Kitne px scroll ke baad class add karni hai
  var scrollThreshold = 50;

  // Konsi class add/remove karni hai
  var scrolledClass = 'is-scrolled';

  if (!header) {
    console.warn('shoaib-dev.js: header element nahi mila (page-header / #pageheader check karein)');
    return;
  }

  function handleScroll() {
    if (window.scrollY > scrollThreshold) {
      header.classList.add(scrolledClass);
    } else {
      header.classList.remove(scrolledClass);
    }
  }

  // Scroll event - passive true taake performance behtar rahe
  window.addEventListener('scroll', handleScroll, { passive: true });

  // Page load hote hi ek baar check kar lo (agar already scrolled ho)
  handleScroll();

});